<template>
  <section class="banner" :style="bannerStyle" :aria-label="title || '页面横幅'">
    <div class="banner__media" aria-hidden="true">
      <img :src="resolvedImage" alt="" />
    </div>
    <div class="banner__veil"></div>
    <div class="banner__content">
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
      <span class="banner__line"></span>
    </div>
  </section>
</template>

<script>
import defaultBanner from "../assets/img/bgtop.jpg";

export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: ""
    }
  },
  computed: {
    resolvedImage() {
      return this.img || defaultBanner;
    },
    bannerStyle() {
      return {
        backgroundImage: `linear-gradient(110deg, var(--veil-strong), var(--veil-mid)), url(${this.resolvedImage})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  display: grid;
  width: 100%;
  height: clamp(260px, 27vw, 360px);
  place-items: center;
  overflow: hidden;
  isolation: isolate;
  background-position: center;
  background-size: cover;
}

.banner::before,
.banner::after {
  content: "";
  position: absolute;
  z-index: -1;
  pointer-events: none;
}

.banner::before {
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 72px 72px;
  mask-image: linear-gradient(to right, transparent, #000 30%, #000 70%, transparent);
}

.banner::after {
  right: -100px;
  bottom: -150px;
  width: 420px;
  height: 420px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 50%;
  box-shadow: 0 0 0 48px rgba(255, 255, 255, 0.04), 0 0 0 96px rgba(255, 255, 255, 0.025);
}

.banner__media {
  position: absolute;
  inset: -18px;
  z-index: -3;
  opacity: 0.24;
  filter: blur(14px) saturate(0.8);
}

.banner__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner__veil {
  position: absolute;
  inset: 0;
  z-index: -2;
  background: linear-gradient(180deg, transparent, var(--veil-soft));
}

.banner__content {
  width: min(calc(100% - 40px), var(--content-width));
  color: #fff;
  text-align: center;
}

.banner h1 {
  font-size: var(--text-display);
  font-weight: 600;
  line-height: 1.16;
  letter-spacing: 0.12em;
  text-shadow: 0 12px 32px rgba(0, 0, 0, 0.22);
}

.banner p {
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.66);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
}

.banner__line {
  display: block;
  width: 48px;
  height: 3px;
  margin: 22px auto 0;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--accent-300), #fff);
}

@media (max-width: 768px) {
  .banner {
    height: 180px;
  }

  .banner::before {
    background-size: 42px 42px;
  }

  .banner::after {
    right: -160px;
    bottom: -220px;
  }

  .banner h1 {
    font-size: 30px;
    letter-spacing: 0.08em;
  }

  .banner p {
    margin-top: 8px;
    font-size: 10px;
    letter-spacing: 0.22em;
  }

  .banner__line {
    margin-top: 16px;
  }
}
</style>
